import React, { forwardRef, useState } from 'react'
import { Button, Grid, Popconfirm, Row, Table, Tooltip } from 'antd'
import BikeModal from '../modals/BikeModal'
import IntlMessage from 'components/util-components/IntlMessage'
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons'
import utils from 'utils'
import { translate } from 'utils/react-jarvisly-helper'
import { useIntl } from 'react-intl'
import { substitution } from 'utils/helpers'
import ImageDescription from 'components/jarvisly/ImageDescription'
import imgBike from 'assets/img/bike.png'
import { pullSubdocumentByUri, putByUri } from 'components/jarvisly-layouts/ModuleComponent/module-api'
import { capitalize, clone } from 'jarvisly-helper'
import { FormNextPrevious, FormTitle } from '../../../FormComponets'

const setLocale = (isLocaleOn, localeKey) => isLocaleOn ? <IntlMessage id={localeKey}/> : localeKey.toString()

// STEP 4 BIKES COMPONENT ******************************************************
// *****************************************************************************

const BikesStep = forwardRef((props, ref) => {

  // props deconstruction ------------------------------------------------------
  const { _dataRoots, _data, dataContext, setDataContext, step, setStep } = props

  // local variables -----------------------------------------------------------
  const { useBreakpoint } = Grid
  const sm = utils.getBreakPoint(useBreakpoint()).includes('sm')
  const md = utils.getBreakPoint(useBreakpoint()).includes('md')
  const intl = useIntl()
  const t = buildTranslations()
  const columns = buildBikesTableColumn()

  // component states ----------------------------------------------------------
  const [showBikeModal, setShowBikeModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState()

  // hooks ---------------------------------------------------------------------

  // methods -------------------------------------------------------------------

  const onAdd = () => {
    setSelectedRecord(null)
    setShowBikeModal(true)
  }

  const onEdit = (record) => {
    setSelectedRecord(record)
    setShowBikeModal(true)
  }

  const onDelete = async _id => {

    setDataContext({ ...dataContext, partialLoading: true })

    const doc = await pullSubdocumentByUri('/atualiza-info', _id, 'bikes')
    await putByUri('/atualiza-info', _dataRoots?._id, { bikesUpdated: false })

    setDataContext({
      ...dataContext, data: { ...doc }, dataLock: { ...clone(doc) }, partialLoading: false,
    })

  }

  const onNextStep = async () => {
    if (_dataRoots.currentStep <= step) {

      setDataContext({ ...dataContext, partialLoading: true })

      const body = { currentStep: step + 1 }
      const doc = await putByUri('/atualiza-info', _dataRoots?._id, body)

      setDataContext({
        ...dataContext, data: { ...doc }, dataLock: { ...clone(doc) }, partialLoading: false,
      })
    }

    // setStep(prev => prev + 1)
  }

  // UI COMPONENT --------------------------------------------------------------

  return (<>

    <BikeModal {...props}
               showModal={showBikeModal}
               setShowModal={setShowBikeModal}
               record={selectedRecord}/>

    {_data?.length > 0 && <div>

      {/* BIKES */}
      <FormTitle title={'bikes'}/>

      <Table rowKey="_id"
             pagination={false}
             columns={columns?.filter(c => !c.hidden) || []}
             dataSource={_data}
             loading={dataContext?.partialLoading}/>
    </div>}


    <Row justify="center" align="middle" className="m-3 mt-4">

      <Button type="primary"
              disabled={_dataRoots?.updateSentAt}
              onClick={onAdd}>
        {setLocale(true, 'add_bike')}
      </Button>

    </Row>
    {/* BIKES */}


    {/* PREVIOUS AND NEXT BUTTON */}
    <FormNextPrevious dataContext={dataContext}
                      step={step}
                      setStep={setStep}
                      onNextClick={onNextStep}
                      _dataRoots={_dataRoots}/>
    {/* PREVIOUS AND NEXT BUTTON */}


  </>)

  // INTERNAL FUNCTIONS ========================================================
  // ===========================================================================

  function buildTranslations () {

    const remove_this_item = translate(intl, 'remove_this_item')
    const bike = translate(intl, 'bike')
    const t_remove_this_item = substitution(remove_this_item, ['%ITEM%'], [bike])

    return {
      remove_this_item: t_remove_this_item,
    }
  }

  function buildBikesTableColumn () {
    return [

      {
        title: setLocale(true, 'model'), render: (_, record) => (<div className="text-left">
          <ImageDescription
            shape="square"
            imageUrl={imgBike}
            title={record?.model?.toUpperCase()}
            subtitle={capitalize(record?.brand)}
            style={{ padding: 10 }}
            backColor="#ecf2fe"
          />
        </div>),
      },

      {
        title: setLocale(true, 'rim'), width: 80,
        hidden: !md,
        render: (_, record) => (<div className="text-left text-uppercase">
          {record?.rim}"
        </div>),
      },

      {
        title: setLocale(true, 'color'),
        hidden: !sm,
        render: (_, record) => (<div className="text-left text-capitalize">
          {setLocale(true, record?.color)}
        </div>),
      },

      {
        title: setLocale(true, 'actions'),
        dataIndex: 'actions',
        width: 120, //113
        className: 'text-center',
        render: (_, record) => {
          return (<>
            <Tooltip title={setLocale(true, !_dataRoots?.updateSentAt ? 'edit' : 'view')}>
              <Button size="small"
                // className={!isMobile ? 'mr-2' : 'mb-2'}
                      className="m-2"
                      icon={!_dataRoots?.updateSentAt ? <EditOutlined/> : <EyeOutlined/>}
                      onClick={() => onEdit(record)}/>
            </Tooltip>

            {!_dataRoots?.updateSentAt && <Popconfirm title={t.remove_this_item}
                                                      cancelButtonProps={{ className: 'fixed-with-90' }}
                                                      okButtonProps={{ className: 'fixed-with-90' }}
                                                      onConfirm={() => onDelete(record?._id)}>
              <Button size="small" icon={<DeleteOutlined/>}/>
            </Popconfirm>}
          </>)
        },
      }]
  }

})

// EXPORT **********************************************************************
// *****************************************************************************

export default BikesStep


